import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
const Index = () => import('../page/index.vue');
//首页
const home = () => import('../page/home/home.vue');
//会议室预订首页
const meetingroombook = () => import('../page/modulepages/meetingroombook.vue');
//人才服务首页
const humanservice = () => import('../page/modulepages/humanservice.vue');
//商标注册首页
const trademarkregister = () => import('../page/modulepages/trademarkregister.vue');
//办公装修首页
const officedecoration = () => import('../page/modulepages/officedecoration.vue');
//工商财税首页
const businesstax = () => import('../page/modulepages/businesstax.vue');
//办公采购首页
const officeprocurement = () => import('../page/modulepages/officeprocurement.vue');
//地图页
const changecity = () => import('../page/home/changecity.vue');
//登录页
const login = () => import('../page/registerlogin/login.vue');
//注册页
const register = () => import('../page/registerlogin/register.vue');
//注册页
const regagreement = () => import('../page/registerlogin/regagreement.vue');
//快捷登录跳信息填写
const fastregister = () => import('../page/registerlogin/fastregister.vue');
//找回密码
const retrievepassword = () => import('../page/registerlogin/retrievepassword.vue');
//用户中心管理
const userCenter = () => import('../page/usercenter/usercenter.vue');
//用户信息
const centerInfo = () => import('../page/usercenter/centerinfo.vue');
//个人信息
const personalInfo =() => import ('../page/usercenter/personinfo.vue');
//企业信息
const companyInfo =() => import ('../page/usercenter/companyinfo.vue');
//修改密码
const changePassWord =() => import ('../page/usercenter/changepassword.vue');
//联系地址
const userAddress =() => import ('../page/usercenter/useraddress.vue');
//发票抬头
const receipt =() => import ('../page/usercenter/receipt.vue');
//支付方式
const paymode =() => import ('../page/usercenter/paymode.vue');
//我的返现
const cashback =() => import ('../page/usercenter/cashback.vue');
//提现记录
const withdrawalrecord =() => import ('../page/usercenter/withdrawalrecord.vue');
//返现明细
const cashbackdetails =() => import ('../page/usercenter/cashbackdetails.vue');
//提现账号
const withdrawalaccount =() => import ('../page/usercenter/withdrawalaccount.vue');
// 提现须知
const withdrawalNotice = () => import('../page/common/withdrawalNotice.vue')

//订单列表
const orderList = () => import('../page/usercenter/orderlist/orderlist.vue')
//订单详情
const orderDetail = () => import('../page/usercenter/orderdetail.vue')
//申请开票
const applyReceipt = () => import('../page/usercenter/applyreceipt.vue')
//开票详情
const receiptDetail = () => import('../page/usercenter/receiptdetail.vue')
//申请退款
const applyRefund = () => import('../page/usercenter/applyrefund.vue')
//退款详情
const refundDetail = () => import('../page/usercenter/refunddetail.vue')
//商品详情
const productInfo = () => import('../page/product/productinfo.vue')
//确认订单
const submitOrder = () => import('../page/product/submitOrder.vue')
//分类商品列表
const searchList = () => import('../page/searchpages/searchlist.vue')
//搜索商品列表
const categoryList = () => import('../page/searchpages/categorylist.vue')
//采购车
const shopCart = () => import('../page/product/shopCart.vue')
//收银台
const cashier = () => import('../page/pay/cashier.vue')
//支付方式
const payway = () => import('../page/pay/index.vue')
//支付方式单页面
const payMethod = () => import('../page/common/payMethod.vue')
//补登
const repair = () => import('../page/pay/repair.vue')
//第三方支付展示页面
const applay = () => import('../page/pay/applay.vue')
//支付成功页
const paysuccess = () => import('../page/pay/paysuccess.vue')
//选择货到付款成功页
const CODsuccess = () => import('../page/pay/CODsuccess.vue')


Vue.use(Router)

const router = new Router({
  routes: [
      {
          path: '/',
          component: home,
          name: 'home',
          meta:{
            title: '青邦 — 一站式企业服务平台，让创业更简单！'
          }
      },
      {
          path: '/changecity',
          component: changecity,
          name: 'changecity',
          meta:{
              title: '切换城市'
          }
      },
      {
          path: '/meetingroombook',
          component: meetingroombook,
          name: 'meetingroombook',
          meta:{
              title: '会议室预订'
          }
      },
      {
          path: '/humanservice',
          component: humanservice,
          name: 'humanservice',
          meta:{
              title: '人才服务'
          }
      },
      {
          path: '/trademarkregister',
          component: trademarkregister,
          name: 'trademarkregister',
          meta:{
              title: '商标注册'
          }
      },
      {
          path: '/officedecoration',
          component: officedecoration,
          name: 'officedecoration',
          meta:{
              title: '办公装修'
          }
      },
      {
          path: '/businesstax',
          component: businesstax,
          name: 'businesstax',
          meta:{
              title: '工商财税'
          }
      },
      {
          path: '/officeprocurement',
          component: officeprocurement,
          name: 'officeprocurement',
          meta:{
              title: '办公采购'
          }
      },
      {
          path: '/regagreement',
          component: regagreement,
          name: 'regagreement',
          meta:{
              title: '注册协议'
          }
      },
      {
          path: '/login',
          component: login,
          name: 'login',
          meta:{
              title: '登录'
          }
      },
      {
          path: '/register',
          component: register,
          name: 'register',
          meta:{
              title: '注册'
          }
      },
      {
          path: '/fastregister',
          component: fastregister,
          name: 'fastregister',
          meta:{
              title: '快速注册'
          }
      },
      {
          path: '/retrievepassword',
          component: retrievepassword,
          name: 'retrievepassword',
          meta:{
              title: '忘记密码'
          }
      },
      {
        path: '',
        component: userCenter,
        name: '',
        redirect: '',
        children: [
          {
            path: 'centerinfo',
            component: centerInfo,
              meta:{
                  title: '我的青邦'
              }
          },
          {
            path: 'orderlist',
            component: orderList,
              meta:{
                  title: '订单列表页'
              }
          },
          {
            path: 'personinfo',
            component: personalInfo,
              meta:{
                  title: '个人中心'
              }
          },
          {
            path: 'companyinfo',
            component: companyInfo,
              meta:{
                  title: '企业信息'
              }
          },
          {
            path: 'changepassword',
            component: changePassWord,
              meta:{
                  title: '修改密码'
              }
          },
          {
            path: 'useraddress',
            component: userAddress,
              meta:{
                  title: '联系地址'
              }
          },
          {
            path: 'receipt',
            component: receipt,
              meta:{
                  title: '发票抬头'
              }
          },
          {
            path: 'paymode',
            component: paymode,
              meta:{
                  title: '支付方式'
              }
          },
            {
                path: 'cashback',
                component: cashback,
                meta:{
                    title: '我的返现'
                }
            },
            {
                path: 'withdrawalrecord',
                component: withdrawalrecord,
                meta:{
                    title: '提现记录'
                }
            },
            {
                path: 'cashbackdetails',
                component: cashbackdetails,
                meta:{
                    title: '返现明细'
                }
            },
            {
                path: 'withdrawalaccount',
                component: withdrawalaccount,
                meta:{
                    title: '提现账号'
                }
            }
        ]
      },
      {
          path: '/withdrawalNotice',
          component: withdrawalNotice,
          name: 'withdrawalNotice',
          meta:{
              title: '提现须知'
          }
      },
      {
          path: '/payMethod',
          component: payMethod,
          name: 'payMethod',
          meta:{
              title: '支付方式'
          }
      },
      {
        path: '/orderDetail',
        component: orderDetail,
        name: 'orderDetail',
          meta:{
              title: '订单详情页'
          }
      },
      {
        path: '/applyReceipt',
        component: applyReceipt,
        name: 'applyReceipt',
          meta:{
              title: '申请开票页'
          }
      },
      {
        path: '/receiptDetail',
        component: receiptDetail,
        name: 'receiptDetail',
          meta:{
              title: '开票详情页'
          }
      },
      {
        path: '/applyRefund',
        component: applyRefund,
        name: 'applyRefund',
          meta:{
              title: '申请退款页'
          }
      },
      {
        path: '/refundDetail',
        component: refundDetail,
        name: 'refundDetail',
          meta:{
              title: '退款详情页'
          }
      },
      {
        path: '/productinfo',
        component: productInfo,
        name: 'productinfo',
          meta:{
              title: '商品详情页'
          }
      }
      ,
      {
        path: '/submitorder',
        component: submitOrder,
        name: 'submitorder',
          meta:{
              title: '确认订单页'
          }
      },
      {
        path: '/searchlist',
        component: searchList,
        name: 'searchlist',
          meta:{
              title: '搜索列表页'
          }
      },
      {
        path: '/categorylist',
        component: categoryList,
        name: 'categorylist',
          meta:{
              title: '商品列表页'
          }
      },
      {
        path: '/shopcart',
        component: shopCart,
        name: 'shopcart',
          meta:{
              title: '购物车'
          }
      },
      {
        path: '',
        component: cashier,
        name: '',
        redirect: '',
        children: [
          {
            path: 'cashier',
            component: payway,
              meta:{
                  title: '收银台'
              }
          },
          {
            path: 'repair',
            component: repair,
              meta:{
                  title: '其它支付页'
              }
          }
        ]
      },
      {
        path: '/applay',
        component: applay,
        name: 'applay',
          meta:{
              title: ''
          }
      },
      {
        path: '/paysuccess',
        component: paysuccess,
        name: 'paysuccess',
          meta:{
              title: '支付成功页'
          }
      },
      {
          path: '/codsuccess',
          component: CODsuccess,
          name: 'CODsuccess',
          meta:{
              title: '成功货到付款'
          }
      }
  ]
})

export default router;
/*路由跳转之前执行*/
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.path == '/home') {
    next({ path: '/' });
  } else {
    next();
  }
})
/*路由跳转之后执行*/
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})



// WEBPACK FOOTER //
// ./src/router/index.js